/**
 * This data is stored at /sessions/{sessionId}/userSettings/{userId}
 * Contains user-specific settings for a given session
 */

export enum ModuleConnectionSize {
  Full = 'Full',
  Half = 'Half',
  Compact = 'Compact',
}

interface SourceSearchAll {
  type: 'all';
}

interface SourceSearchVisible {
  type: 'visible';
}

interface SourceSearchCustomFields {
  type: 'custom';
  fieldIds: string[];
}

export type SourceSearchSetting = SourceSearchAll | SourceSearchVisible | SourceSearchCustomFields;

interface QueueSearchAll {
  type: 'all';
  messages: boolean;
}

interface QueueSearchVisible {
  type: 'visible';
  messages: boolean;
}

interface QueueSearchModule {
  type: 'module';
  moduleId: string;
  fieldIds: string[];
}

export type QueueSearchSetting = QueueSearchAll | QueueSearchVisible | QueueSearchModule;

export type SnackbarPosition =
  | 'top-center'
  | 'top-right'
  | 'bottom-right'
  | 'bottom-center'
  | 'bottom-left';

/**
 * Per-user visibility settings for card metadata (priority, dates, issues).
 * All default to true when not set.
 */
export interface CardMetaVisibility {
  showPriority?: boolean;
  showDates?: boolean;
  showIssues?: boolean;
}

export interface FirestoreUserSettings {
  sourceSearch?: Record<string, SourceSearchSetting>;
  queueSearch?: QueueSearchSetting;
  connectionDisplaySettings?: Record<string, ModuleConnectionSize>;
  privateNotes?: string;
  showSnackbarNotifications?: boolean;
  snackbarPosition?: SnackbarPosition;
  cardMetaVisibility?: CardMetaVisibility;
}

export interface FirestoreUser {
  canUseApp: boolean;
  userId: string;
  email: string;
  name: string;
  photoURL: string | null;
  organizationId?: string; // Optional organization ID for users who belong to an organization
  hasOrganization?: boolean;
  organizationRole?: string;
  /** Session IDs this user hid from Active/Done (Spike 3); Done still wins when session is archived */
  hiddenSessions?: string[];
}
